import {Component} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {CommonModule} from '@angular/common';
import {TranslateModule} from "@ngx-translate/core";
import {TalentAvailabilityApiService} from "../talent-availability-api.service";

@Component({
  selector: 'app-email-cancellation',
  templateUrl: './email-cancellation.component.html',
  styleUrls: ['./email-cancellation.component.scss'],
  standalone: false,
})
export class EmailCancellationComponent {
  talentAvailable = true;
  obfuscatedTalentId: string;
  error: boolean = false;
  isLoading: boolean = true;

  constructor(
      private route: ActivatedRoute,
      private api: TalentAvailabilityApiService
  ) {
      this.obfuscatedTalentId = this.route.snapshot.paramMap.get('obfuscatedTalentId');
      if (this.route.snapshot.queryParamMap.get('resubscribe') === 'true') {
        this.makeTalentAvailable();
      } else {
        this.makeTalentUnavailable();
      }
  }

  private handleError(err: any): void {
    this.isLoading = false;
    this.error = true;
  }

  makeTalentUnavailable(): void {
    this.isLoading = true;
    this.talentAvailable = false;
    this.api.setUnavailableToWork(this.obfuscatedTalentId)
        .subscribe({
          next: () => {
            // Successfully made talent unavailable
            this.isLoading = false;
          },
          error: (err) => this.handleError(err),
        });
  }

  makeTalentAvailable(): void {
    this.isLoading = true;
    this.talentAvailable = true;
    this.api.setAvailableToWork(this.obfuscatedTalentId)
        .subscribe({
          next: () => {
            // Successfully made talent available
            this.isLoading = false;
          },
          error: (err) => this.handleError(err),
        });
  }
}
